// src/modules/Rules/adapters/ShopApiAdapter.ts
import { HttpClient } from '@adapters/HttpClient';
import type { Option } from './ConditionApiAdapter';

export class ShopApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<Option[]> {
    const raw = await this.httpClient.get<any>('/shops');
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((s: any) => ({
      id: String(s.id),
      name: s.name,
    }));
  }
}
